<template>
  <div>
    <span v-html="mediaObject.description"></span>
  </div>
</template>

<script>
import ExternalMediaObject from './ExternalMediaObject'
export default {
  name: 'CommunityEventsObject',
  mixins: [ExternalMediaObject]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/socialMedia/CommunityEventsObject.vue